<template>
  <div>
    <province-selector-constraint
      v-if="type === optionValue.province"
      :data-source="provinceSource"
      :allowed-values.sync="provinceAllowedValues"
      :forbidden-values.sync="provinceForbiddenValues"
    />
    <city-selector-constraint
      v-if="type === optionValue.city"
      :provinces="provinceSource"
      :allowed-values.sync="cityAllowedValues"
      :forbidden-values.sync="cityForbiddenValues"
    />
    <county-selector-constraint
      v-if="type === optionValue.county"
      :provinces="provinceSource"
      :allowed-values.sync="countyAllowedValues"
      :forbidden-values.sync="countyForbiddenValues"
    />
  </div>
</template>

<script>
import ProvinceSelectorConstraint from "@/components/excel/designer/configure/value/area/ProvinceSelectorConstraint";
import CitySelectorConstraint from "@/components/excel/designer/configure/value/area/city-selector-constraint";
import CountySelectorConstraint from "@/components/excel/designer/configure/value/area/county-selector-constraint";

import {
  CityOption,
  CountyOption,
  ProvinceOption,
} from "@/components/excel/schema/label/type/area";
import {AreaSharedCache} from "@/utils/AreaSharedCache";

export default {
  name: "area-single-selector-constraint",
  components: {
    CountySelectorConstraint,
    CitySelectorConstraint,
    ProvinceSelectorConstraint,
  },
  props: {
    type: {
      type: Number,
    },
    forbiddenValues: {
      type: Array,
    },
    allowedValues: {
      type: Array,
    },
  },
  watch: {
    forbiddenValues(values) {
      this.province.forbiddenValues = [];
      this.city.forbiddenValues = [];
      this.county.forbiddenValues = [];
      switch (this.$props.type) {
        case this.optionValue.province:
          this.province.forbiddenValues = values || [];
          break;
        case this.optionValue.city:
          this.city.forbiddenValues = values || [];
          break;
        case this.optionValue.county:
          this.county.forbiddenValues = values || [];
      }
    },
    allowedValues(values) {
      this.province.allowedValues = [];
      this.city.allowedValues = [];
      this.county.allowedValues = [];
      switch (this.$props.type) {
        case this.optionValue.province:
          this.province.allowedValues = values || [];
          break;
        case this.optionValue.city:
          this.city.allowedValues = values || [];
          break;
        case this.optionValue.county:
          this.county.allowedValues = values || [];
      }
    },
  },
  computed: {
    provinceAllowedValues: {
      get() {
        return this.province.allowedValues;
      },
      set(value) {
        const current = value || [];
        this.province.allowedValues = current;
        this.emitChangeAllowedValues(current);
      },
    },
    cityAllowedValues: {
      get() {
        return this.city.allowedValues;
      },
      set(value) {
        const current = value || [];
        this.city.allowedValues = current;
        this.emitChangeAllowedValues(current);
      },
    },
    countyAllowedValues: {
      get() {
        return this.county.allowedValues;
      },
      set(value) {
        const current = value || [];
        this.county.allowedValues = current;
        this.emitChangeAllowedValues(current);
      },
    },
    provinceForbiddenValues: {
      get() {
        return this.province.forbiddenValues;
      },
      set(value) {
        const current = value || [];
        this.province.forbiddenValues = current;
        this.emitChangeForbiddenValues(current);
      },
    },
    cityForbiddenValues: {
      get() {
        return this.city.forbiddenValues;
      },
      set(value) {
        const current = value || [];
        this.city.forbiddenValues = current;
        this.emitChangeForbiddenValues(current);
      },
    },
    countyForbiddenValues: {
      get() {
        return this.county.forbiddenValues;
      },
      set(value) {
        const current = value || [];
        this.county.forbiddenValues = current;
        this.emitChangeForbiddenValues(current);
      },
    },
  },
  mounted() {
    AreaSharedCache.loadChildren(0).then((it) => (this.provinceSource = it || []));
  },
  data() {
    return {
      provinceSource: [],
      province: {
        allowedValues: null,
        forbiddenValues: null,
      },
      city: {
        allowedValues: null,
        forbiddenValues: null,
      },
      county: {
        allowedValues: null,
        forbiddenValues: null,
      },
      optionValue: {
        province: ProvinceOption.value,
        city: CityOption.value,
        county: CountyOption.value,
      },
    };
  },
  methods: {
    emitChangeAllowedValues(value) {
      this.$emit("update:allowed-values", value);
      this.$emit("change-allowed-values", value);
    },
    emitChangeForbiddenValues(value) {
      this.$emit("update:forbidden-values", value);
      this.$emit("change-forbidden-values", value);
    },
  },
};
</script>
